import { render, staticRenderFns } from "./svgDigikala.vue?vue&type=template&id=820a5432"
import script from "./svgDigikala.vue?vue&type=script&lang=js"
export * from "./svgDigikala.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports